module.exports = __webpack_public_path__ + "components/country-flag/static/nu-2d9c15c308eff50f974fa2c3939ac8c9.svg";